<agr-page-detail
  [pageTitle]="
    ('fieldOverview' | translate) + ' ' + (cropYear$ | async) + ', ' + (customer$ | async)?.name
  "
  [hasPrimaryAction]="
    (groupedCropFields$ | async)?.mainCultivations.length > 0 ||
    (groupedCropFields$ | async)?.subsequentCultivations.length > 0
  "
  [isEmpty]="
    (groupedCropFields$ | async)?.mainCultivations.length === 0 &&
    (groupedCropFields$ | async)?.subsequentCultivations.length === 0
  "
  [emptyTitle]="'noCropFieldsTitle' | translate"
  [emptyDescription]="'noCropFieldsDescription' | translate"
  primaryActionIcon="precision_manufacturing"
  [primaryActionText]="'printOverview' | translate"
  (primaryAction)="print()"
  (backAction)="back()"
  [buttonItems]="buttonItems$ | async"
  (buttonAction)="buttonAction($event)"
>
  <agr-print-page [marginLeft]="true" [showPageNumber]="false">
    <div class="page-break-before">
      <div class="spacing--margin-vertical">
        <app-general-info></app-general-info>
      </div>
      <div class="spacing--margin-vertical">
        <app-cropfield-data [print]="'true'"></app-cropfield-data>
      </div>
    </div>
  </agr-print-page>
</agr-page-detail>
